{
  "whatToDo": {
    "fr-FR": "à faire",
    "en-US": "what to do",
    "en-GB": "what to do",
    "es-ES": "what to do",
    "de-DE": "was zu machen"
  },
  "whatToSee": {
    "fr-FR": "à voir",
    "en-US": "what to see",
    "en-GB": "what to see",
    "es-ES": "what to see",
    "de-DE": "was zu sehen"
  },
  "whereToSleep": {
    "fr-FR": "où dormir",
    "en-US": "where to sleep",
    "en-GB": "where to sleep",
    "es-ES": "where to sleep",
    "de-DE": "wo zu schlafen"
  },
  "whereToEat": {
    "fr-FR": "où manger",
    "en-US": "where to eat",
    "en-GB": "where to eat",
    "es-ES": "where to eat",
    "de-DE": "wo zu essen"
  },
  "localProducts": {
    "fr-FR": "produits locaux",
    "en-US": "local products",
    "en-GB": "local products",
    "es-ES": "local products",
    "de-DE": "lokale Produkte"
  },
  "services": {
    "fr-FR": "services",
    "en-US": "services",
    "en-GB": "services",
    "es-ES": "services",
    "de-DE": "Service"
  },
  "agenda": {
    "fr-FR": "agenda",
    "en-US": "schedule",
    "en-GB": "schedule",
    "es-ES": "schedule",
    "de-DE": "Kalender"
  }
}
